const noop = () => null;
const debugMode = process.env.REACT_APP_DEBUG === 'true';

export const consoleHelper = {
  log: debugMode ? console.log : noop,
};
